const patronReviewHostRegex =
  /^deploy-preview-(\d+)--whoosh-patron-master\.netlify\.app$/;

type PatronLocation = Pick<Location, "host" | "protocol">;

export const buildStaffAppUrl = (location: PatronLocation): string => {
  if (
    location.host === "localhost:8081" ||
    location.host === "127.0.0.1:8081"
  ) {
    return `${location.protocol}//${location.host.replace(":8081", ":3000")}/`;
  }

  const reviewHostMatch = location.host.match(patronReviewHostRegex);

  if (!reviewHostMatch) {
    return "/";
  }

  const prNumber = reviewHostMatch[1];
  return `${location.protocol}//deploy-preview-${prNumber}--whoosh-staff-master.netlify.app/`;
};
